/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  if (!customElements.get('country-popout-select')) {
    const Popout = window.customElements.get('popout-select');
    customElements.define(
      'country-popout-select',
      class CountryPopoutSelect extends Popout {
        constructor() {
          super();
        }

        connectedCallback() {
          this.popoutList = this.querySelector('[data-popout-list]');
          this.popoutInput =
            this.querySelector('[data-popout-input]') ||
            this.parentNode.querySelector('[data-popout-input]') ||
            this.parentNode.parentNode.querySelector('[data-quantity-input]');

          this.popoutOptions = this.querySelectorAll('[data-popout-option]');
          this.productGridItem = this.popoutList.closest('[data-grid-item]');
          this.fireSubmitEvent = this.hasAttribute('submit');
          this.searchInput = this.querySelector('[data-country-search]');
          this.searchNoResults = this.querySelector('[data-search-no-results]');
          this.searchOptions = this.querySelectorAll('[data-search-option]');

          this.popupToggleFocusoutEvent = (evt) => this.onPopupToggleFocusout(evt);
          this.popupListFocusoutEvent = (evt) => this.onPopupListFocusout(evt);
          this.popupToggleClickEvent = (evt) => this.onPopupToggleClick(evt);
          this.keyUpEvent = (evt) => this.onKeyUp(evt);
          this.bodyClickEvent = (evt) => this.onBodyClick(evt);

          this._connectOptions();
          this._onFocusOut();
          this._onSearch();
        }

        _onFocusOut() {
          this.addEventListener('keyup', this.keyUpEvent);
          this.popoutList.addEventListener('focusout', this.popupListFocusoutEvent);
        }

        _onSearch() {
          if (!this.searchInput || !this.searchOptions.length) return;
          const searchHandler = window.theme.debounce(this.countryFilter.bind(this), 300);
          this.searchInput.addEventListener('input', searchHandler);
        }

        countryFilter() {
          if (!this.searchInput) return;
          const filter = this.searchInput.value.toLowerCase();
          const isFiltered = Boolean(filter);
          this.classList.toggle('popout--filtered', isFiltered);
          let hasResults = false;
          this.searchOptions.forEach((option) => {
            const text = option.textContent.toLowerCase();
            const match = text.includes(filter);
            option.classList.toggle('hidden', !match);
            if (match) hasResults = true;
          });

          if (this.searchNoResults) {
            this.searchNoResults.classList.toggle('hidden', hasResults || !isFiltered);
          }
        }
      },
    );
  }

  if (!customElements.get('jwt-validator')) {
    customElements.define(
      'jwt-validator',
      class JWTValidator extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          // Message nodes are toggled based on validation outcome.
          this.successMessageElement = this.querySelector('[data-temera-success-message]');
          this.errorMessageElement = this.querySelector('[data-temera-error-message]');
          this.unsupportedMessageElement = this.querySelector('[data-temera-unsupported-message]');
          // Config comes from section data attributes.
          const queryParamName = this.dataset.jwtParam || 'jwt';
          const publicKeyPem = this.dataset.publicKeyPem || '';

          // JWT token is expected in the URL query string.
          const jwtToken = new URLSearchParams(window.location.search).get(queryParamName);

          // Missing input means we cannot validate, so fail closed.
          if (!jwtToken || !publicKeyPem) {
            this.showError();
            return;
          }

          // Run async signature/time validation and update UI accordingly.
          this.constructor.validateJwtRS512(jwtToken, publicKeyPem).then((result) => {
            if (result.valid) {
              this.showSuccess();
            } else {
              this.showError();
            }
          });
        }

        showUnsupportedError() {
          if (this.unsupportedMessageElement) this.unsupportedMessageElement.classList.remove('hidden');
        }

        showSuccess() {
          if (this.successMessageElement) this.successMessageElement.classList.remove('hidden');
        }

        showError() {
          if (this.errorMessageElement) this.errorMessageElement.classList.remove('hidden');
        }

        static base64UrlToBytes(base64UrlValue) {
          // JWT segments are Base64URL, normalize to regular Base64 first.
          let normalizedValue = base64UrlValue.replace(/-/g, '+').replace(/_/g, '/');
          const padding = normalizedValue.length % 4;

          if (padding === 2) normalizedValue += '==';
          if (padding === 3) normalizedValue += '=';
          if (padding === 1) throw new Error('Invalid base64url string');

          if (typeof atob !== 'function' || typeof Uint8Array !== 'function') {
            this.showUnsupportedError();
            throw new Error('Base64 decoding is not supported in this environment');
          }

          const binary = atob(normalizedValue);
          const bytes = new Uint8Array(binary.length);
          for (let i = 0; i < binary.length; i += 1) {
            bytes[i] = binary.charCodeAt(i);
          }

          return bytes;
        }

        static utf8BytesToString(bytes) {
          if (typeof TextDecoder !== 'function') {
            this.showUnsupportedError();
            throw new Error('TextDecoder is not supported in this environment');
          }
          return new TextDecoder().decode(bytes);
        }

        static parsePemPublicKey(pemPublicKey) {
          // Remove PEM envelope and whitespace to get raw SPKI body.
          const pemBody = pemPublicKey
            .replace('-----BEGIN PUBLIC KEY-----', '')
            .replace('-----END PUBLIC KEY-----', '')
            .replace(/\s+/g, '');

          return this.base64UrlToBytes(pemBody.replace(/\+/g, '-').replace(/\//g, '_'));
        }

        static importRs512PublicKey(pemPublicKey) {
          if (!window.crypto || !window.crypto.subtle) {
            this.showUnsupportedError();
            throw new Error('Web Crypto API is not available in this browser');
          }
          // Import key for RSASSA-PKCS1-v1_5 + SHA-512 verification.
          const spkiBytes = this.parsePemPublicKey(pemPublicKey);

          return window.crypto.subtle.importKey(
            'spki',
            spkiBytes.buffer,
            {
              name: 'RSASSA-PKCS1-v1_5',
              hash: 'SHA-512',
            },
            false,
            ['verify'],
          );
        }

        static parseJwt(jwtToken) {
          // JWT must be header.payload.signature.
          const parts = jwtToken.split('.');

          if (parts.length !== 3) {
            throw new Error('JWT must contain exactly 3 dot-separated parts');
          }

          const headerJson = this.utf8BytesToString(this.base64UrlToBytes(parts[0]));
          const payloadJson = this.utf8BytesToString(this.base64UrlToBytes(parts[1]));

          return {
            header: JSON.parse(headerJson),
            payload: JSON.parse(payloadJson),
            signingInput: `${parts[0]}.${parts[1]}`,
            signatureBytes: this.base64UrlToBytes(parts[2]),
          };
        }

        static validateTimeClaims(payload, clockToleranceSeconds) {
          // Compare epoch seconds with optional tolerance to absorb small clock drifts.
          const now = Math.floor(Date.now() / 1000);

          if (typeof payload.nbf === 'number' && now + clockToleranceSeconds < payload.nbf) {
            return { valid: false, error: 'Token is not active yet (nbf)' };
          }

          if (typeof payload.exp === 'number' && now - clockToleranceSeconds >= payload.exp) {
            return { valid: false, error: 'Token has expired (exp)' };
          }

          return { valid: true };
        }

        static async validateJwtRS512(jwtToken, pemPublicKey, options) {
          const config = options || {};
          const clockToleranceSeconds = Number(config.clockToleranceSeconds || 0);

          // Web Crypto is required for browser-side signature verification.
          if (!window.crypto || !window.crypto.subtle) {
            return { valid: false, error: 'Web Crypto API is not available in this browser' };
          }

          if (!jwtToken || !pemPublicKey) {
            return { valid: false, error: 'JWT and public key are required' };
          }

          try {
            const tokenParts = this.parseJwt(jwtToken);

            // Accept only RS512 to avoid algorithm confusion.
            if (tokenParts.header.alg !== 'RS512') {
              this.showUnsupportedError();
              return {
                valid: false,
                error: `Unsupported JWT algorithm: ${String(tokenParts.header.alg || 'unknown')}`,
              };
            }

            const cryptoKey = await this.importRs512PublicKey(pemPublicKey);
            const signedBytes = new TextEncoder().encode(tokenParts.signingInput);

            const signatureValid = await window.crypto.subtle.verify(
              'RSASSA-PKCS1-v1_5',
              cryptoKey,
              tokenParts.signatureBytes,
              signedBytes,
            );

            // Stop early when signature check fails.
            if (!signatureValid) {
              return { valid: false, error: 'Invalid JWT signature' };
            }

            const timeValidation = this.validateTimeClaims(tokenParts.payload, clockToleranceSeconds);

            if (!timeValidation.valid) {
              return timeValidation;
            }

            return {
              valid: true,
              header: tokenParts.header,
              payload: tokenParts.payload,
            };
          } catch (error) {
            return {
              valid: false,
              error: error && error.message ? error.message : 'Unknown JWT validation error',
            };
          }
        }
      },
    );
  }

  function preventHistoryStacking(container) {
    const links = container.querySelectorAll('a[data-prevent-history-stacking]');
    if (links.length) {
      links.forEach((link) => {
        link.addEventListener('click', function (event) {
          event.preventDefault();
          location.replace(link.href);
          return;
        });
      });
    }
  }

  function reinitMeasmerizeSizeChart() {
    if (!measmerize) return;
    // Unmount existing instances
    measmerize.button?.unMount();
    measmerize.modal?.unMount();
    // Remount
    measmerize.button?.mount();
  }

  function handleProductVariantChange() {
    if (window.theme.PUB_SUB_EVENTS) {
      subscribe(theme.PUB_SUB_EVENTS.variantChange, (data) => {
        // Add here any custom code you want to run when the variant changes.
        reinitMeasmerizeSizeChart();
      });
    }
  }

  document.addEventListener('shopify:section:load', (e) => {
    const container = e.target;
    if (typeof container !== 'object' || container.nodeValue === 'undefined') return;

    preventHistoryStacking(container);
  });

  window.addEventListener('DOMContentLoaded', () => {
    preventHistoryStacking(document);
    handleProductVariantChange();
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
